module.exports = __webpack_public_path__ + "img/formPh2.95bce580.svg";